
<h2 mat-dialog-title class="dialog-header">Confirm Update</h2>

<mat-dialog-content>
  <p>You are about to update the following prices:</p>
  <p><strong>Gold (22K):</strong> ₹{{ data.gold }}/g</p>
  <p><strong>Silver:</strong> ₹{{ data.silver }}/g</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
